export function saveService(id_machine, data) {
    let { saveServiceRequest, saveServiceError, saveServiceResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'blackbox/save_service',
        this.createBundle('blackbox/save_service', { id_machine, service: data }, this.POST, saveServiceRequest, saveServiceResult, saveServiceError)
    )
}
